import { render, staticRenderFns } from "./modalDetallePagoTransferencia.vue?vue&type=template&id=66565c9c&scoped=true&"
import script from "./modalDetallePagoTransferencia.vue?vue&type=script&lang=js&"
export * from "./modalDetallePagoTransferencia.vue?vue&type=script&lang=js&"
import style0 from "./modalDetallePagoTransferencia.vue?vue&type=style&index=0&id=66565c9c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66565c9c",
  null
  
)

export default component.exports